import React, { useEffect, useState } from 'react'
import { DocWithPreview } from '../../Common/DocWithPreview'
import { Box, Checkbox, FormControlLabel, Grid, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material'
import TextLabel from '../../Common/CommonTextLabel'
import { makeStyles } from 'tss-react/mui';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { BucketURL } from '../../../ApiSetup/Api';
import CommonTextField from '../../Common/CommonTextField';
import dayjs from 'dayjs'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CommonTextArea from '../CommonTextArea';
import ButtonOutlined from '../../Common/ButtonOutlined';
import ButtonContained from '../../Common/ButtonContained';
import CommonCheckBox from '../CommonCheckBox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useSelector } from 'react-redux';
import { checkAccess } from '../../../Utils/handler';
import { showLoader } from '../../../Redux/Slices/loaderSlice';
import { getAvailableAccess } from '../../../Redux/Actions/action';
import CommonDropDown from '../../Common/CommonDropDown';
import { castTypes } from '../../../Utils/enum';
import ReUploadModal from '../../Common/ReUploadModal';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import sessionStoreUtil from '../../../ApiSetup/Localstorage';


const useStyles = makeStyles()((theme) => {

    return {
        gridBorder: {
            background: theme.palette.secondary.main,
            border: `2px dashed ${theme.palette.bgLightBlack.main}`,
            padding: "10px", // Default value
            borderRadius: "12px",
        },
    }
})
const DobCertification = ({ data, isEdit, setIsEdit, setData, setImagePreView, handleStatusChange, _updateMember, handleInputChange, setValue, handleChange, errors, dataAccess, handleUpload, openDobCertification, setOpenDobCertification }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { classes } = useStyles();
    const theme = useTheme()
    const { pathname } = useLocation()
    const startPathname = pathname?.split('-')[0];
    const user = sessionStoreUtil.getLSItem("userData")        ? JSON.parse(sessionStoreUtil.getLSItem("userData"))        : {};
    // const dataAccess = useSelector(value => value?.allAvailableAccess?.AllAvailableAccessList)

    // // -------- useEffect ----------
    // useEffect(() => {
    //     dispatch(showLoader(true));
    //     dispatch(getAvailableAccess())
    //         .unwrap() // Automatically handles async response
    //         .catch((error) => console.error("error", error))
    //         .finally(() => dispatch(showLoader(false)));
    // }, [dispatch]);

    return (
        <Grid container item xs={12}>

            <Grid item sm={12} xs={12}>
                <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"LC/DOB Certificate "} secondText="(Optional)" secondTextColor={theme.palette.bgLightBlack.main} marginBottom={1} />
                <DocWithPreview
                    docArray={data?.uploadDocuments?.lc_dob_certificate?.image?.length > 0 ? data?.uploadDocuments?.lc_dob_certificate?.image : []}
                    docName={"LC/DOB Certificate"}
                    title='LC/DOB Certificate'
                />
                {((checkAccess(startPathname, dataAccess, 'Reupload Button')) && isEdit.lc_dob_certificate) && <ButtonOutlined
                    startIcon={<CloudSyncOutlinedIcon />}
                    border={"none"}
                    width={"auto"}
                    text={"Reupload"}
                    padding={{ xs: "5px 10px", md: "5px 10px" }}
                    fontSize={{ xs: "12px", md: "14px" }}
                    height={{ xs: "30px", sm: "30px" }}
                    onClick={() => { setOpenDobCertification(true) }}
                />}
            </Grid>

            <Grid container spacing={1} mt={2}>
                <Grid item xs={12} sm={6}>
                    {/* <CommonTextField
                        value={data?.uploadDocuments?.lc_dob_certificate?.cast}
                        text="Cast"
                        type="text"
                        onChange={handleChange}
                        labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                        labelColor={theme?.palette?.primary?.main}
                        height={30}
                        name="cast"
                        disabled={!isEdit.lc_dob_certificate}
                    /> */}
                    <CommonDropDown
                        notShowSelect
                        type="text"
                        text={'Cast'}
                        name={'cast'}
                        value={data?.uploadDocuments?.lc_dob_certificate?.cast || ""}
                        values={castTypes?.map((e) => e?.label) || []}
                        placeholder={`Select your cast`}
                        width={"100%"}
                        valid
                        onChange={(e) => {
                            const { value, name } = e?.target
                            setData(prevData => ({
                                ...prevData,
                                uploadDocuments: {
                                    ...prevData.uploadDocuments,
                                    ['lc_dob_certificate']: {
                                        ...(prevData.uploadDocuments['lc_dob_certificate'] || {}),  // ensure that the section exists
                                        [name]: value?.trimStart(),  // Update only the specified field
                                    }
                                }
                            }));
                        }}
                        disabled={!isEdit.lc_dob_certificate}
                    />
                    <TextLabel color="error" title={!data?.uploadDocuments?.lc_dob_certificate?.cast ? errors?.cast : ""} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <CommonTextField
                        valid
                        value={data?.uploadDocuments?.lc_dob_certificate?.birthPlace}
                        text="Birth Place"
                        type="text"
                        onChange={handleChange}
                        labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                        labelColor={theme?.palette?.primary?.main}
                        height={30}
                        name="birthPlace"
                        disabled={!isEdit.lc_dob_certificate}
                    />
                    <TextLabel color="error" title={!data?.uploadDocuments?.lc_dob_certificate?.birthPlace ? errors?.birthPlace : ""} />
                </Grid>

                <Grid item xs={12}>
                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={1}>
                        {checkAccess(startPathname, dataAccess, 'Edit Action') &&
                            <ButtonContained
                                backgroundColor={!isEdit.lc_dob_certificate ? theme.palette.primary.main : theme.palette.success.main}
                                width={"auto"}
                                text={isEdit.lc_dob_certificate ? "Save" : "Edit"}
                                borderRadius={'20px'}
                                padding={{ xs: "5px 10px", md: "5px 10px" }}
                                fontSize={{ xs: "12px", md: "14px" }}
                                height={{ xs: "30px", sm: "30px" }}
                                onClick={() => { setIsEdit({ lc_dob_certificate: !isEdit?.lc_dob_certificate }) }}
                            />
                        }
                        {checkAccess(startPathname, dataAccess, 'Accept/Reject Action') && data?.verificationStatus !== "Approved" &&
                            <Box display={'flex'} alignItems={'center'} gap={1}>
                                <ToggleButtonGroup
                                    color={data?.lc_dob_certificate?.status == "Approved" ? "success" : "error"}
                                    value={data?.lc_dob_certificate?.status}
                                    exclusive
                                    aria-label="Platform"
                                    size='small'
                                >
                                    <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Approved" onClick={() => handleStatusChange("status", "lc_dob_certificate", "Approved")}>
                                        {data?.lc_dob_certificate?.status == "Approved" ? "Approved" : "Approve"}</ToggleButton>
                                    <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Rejected" onClick={() => handleStatusChange("status", "lc_dob_certificate", "Rejected")}>
                                        {data?.lc_dob_certificate?.status == "Rejected" ? "Rejected" : "Reject"}</ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        }
                        {
                            checkAccess(startPathname, dataAccess, 'Accept/Reject Action') &&
                            data?.verificationStatus == "Approved" && <ButtonOutlined
                                width={"auto"}
                                text={"Approved"}
                                border={"1px dashed green"}
                                color={'green'}
                                borderRadius={'20px'}
                                padding={{ xs: "5px 10px", md: "5px 10px" }}
                                fontSize={{ xs: "12px", md: "14px" }}
                                height={{ xs: "30px", sm: "30px", md: "30px" }}
                                endIcon={<CheckCircleIcon />}
                            />}
                    </Box>
                </Grid>

                {data?.verificationStatus !== "Approved" && data?.lc_dob_certificate?.status == "Rejected" && <Grid item xs={12}>
                    <CommonTextArea
                        label="Reason"
                        value={data?.lc_dob_certificate?.reason}
                        labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                        name='reason'
                        onChange={(e) => handleInputChange(e, "lc_dob_certificate")}
                        rows={2}
                        disabled={user?.organisationName !== "PPSK"}
                    />
                </Grid>}

                {/* <Grid item xs={12} display={"flex"} justifyContent={"flex-end"} gap={1}>
                    <ButtonOutlined
                        width={"auto"}
                        text={"Cancel"}
                        color={"#3E4094"}
                        lineHeight={"24.5px"}
                        backgroundColor={"#fff"}
                        border={"1px solid #3E4094"}
                        padding={{ xs: "5px 10px", md: "10px 20px" }}
                        fontSize={{ xs: "12px", md: "14px" }}
                        height={{ xs: "40px", sm: "40px" }}
                        onClick={() => navigate("/admin/documents")}
                    />

                    <ButtonContained
                        width={"auto"}
                        text={"Confirm"}
                        lineHeight={"24.5px"}
                        padding={{ xs: "5px 10px", md: "10px 20px" }}
                        fontSize={{ xs: "12px", md: "14px" }}
                        height={{ xs: "40px", sm: "40px" }}
                        onClick={() => data?.verificationStatus === "Approved" ? setValue("4") : _updateMember("4")}
                    />
                </Grid> */}
            </Grid>


            {openDobCertification &&
                <ReUploadModal
                    multiple
                    open={openDobCertification}
                    handleClose={() => setOpenDobCertification(false)}
                    onSave={() => setOpenDobCertification(false)}
                    text={"LC/DOB Certificate (LC/DOB પ્રમાણપત્ર)"}
                    name={"image"}
                    onChange={(e) => handleUpload(e, "uploadDocuments", "lc_dob_certificate")}
                    imageValue={data?.uploadDocuments?.lc_dob_certificate?.image}
                />}

        </Grid>
    )
}

export default DobCertification
